module.exports = __webpack_public_path__ + "static/media/corona.f48c7b09.jpg";